import compose from 'lodash/flowRight'
import PropTypes from 'prop-types'

import withRouterCustom from 'utils/hoc/withRouterCustom'
import { getDisplayName, getUrlParam } from 'utils/mixpanel'
import { withMixpanel } from 'utils/sdks/mixpanel'

export const withAnalytics = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { mixpanel, location } = props
    const trackers = {
      trackAssignClick: (isConnected) =>
        mixpanel.track('Orders List_Orders Assigned', {
          ...getUrlParam(location),
          ConnectionStatus: isConnected ? 'Existing' : 'New',
        }),
    }
    return <WrappedComponent {...props} {...trackers} />
  }

  Wrapper.propTypes = {
    mixpanel: PropTypes.object,
    location: PropTypes.object.isRequired,
  }

  Wrapper.defaultProps = {
    mixpanel: { track: () => {} },
  }

  Wrapper.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`
  return compose(withRouterCustom, withMixpanel)(Wrapper)
}

export default withAnalytics
